var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNairaWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 9V1.70133C2.33328 1.54622 2.38476 1.39548 2.47968 1.27279C2.57459 1.1501 2.70757 1.06242 2.85773 1.0235C3.00788 0.984592 3.16671 0.996657 3.30927 1.0578C3.45182 1.11895 3.57003 1.22572 3.64533 1.36133L7.68798 8.63867C7.76327 8.77428 7.88148 8.88105 8.02404 8.9422C8.16659 9.00334 8.32542 9.01541 8.47558 8.9765C8.62574 8.93758 8.75871 8.8499 8.85363 8.72721C8.94855 8.60452 9.00002 8.45378 8.99998 8.29867V1M1 3.66667H10.3333M1 6.33333H10.3333",
    stroke: "#C7C7C7",
    strokeWidth: 1.28,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNairaWhite);
export default __webpack_public_path__ + "static/media/NairaWhite.865b5dc1c5ad71cd64ced838c5cf9a60.svg";
export { ForwardRef as ReactComponent };